import { fetchSingleLineup } from "../../fetch/graphql/requests/lineups";
import { transformAllContentItems } from "../../utils/dataTransform/library";
import { update_single_lineup } from "../../reducers/SingleLineup/reducer";
import log from "../../utils/logger/library";
import { PATHS_WITH_NEWS_BAR } from "../../components/NewsBar/constants";
export const fetch_single_lineup_for_path = (path, limit) => {
    return async (dispatch) => {
        if (Object.keys(PATHS_WITH_NEWS_BAR).includes(path)) {
            const lineupSlug = PATHS_WITH_NEWS_BAR[path]?.lineupSlug;
            const lineupAttributes = PATHS_WITH_NEWS_BAR[path]?.attributes;
            try {
                const { allContentItems } = await fetchSingleLineup({
                    lineupSlug: lineupSlug,
                    categorySlug: "",
                    subjectsSet: "",
                    tags: "",
                });

                const list = transformAllContentItems(allContentItems.nodes);
                const listToRender = limit ? list.slice(0, limit) : list;

                // Only include relevant attributes to reduce the size of the payload and the redux state
                const listToRenderWithRelevantAttributes = listToRender.map(
                    (item) => {
                        const itemAttributes = {};
                        lineupAttributes.map(
                            (attribute) =>
                                (itemAttributes[attribute] = item[attribute])
                        );
                        return itemAttributes;
                    }
                );
                dispatch(
                    update_single_lineup(listToRenderWithRelevantAttributes)
                );
            } catch (error) {
                log.error(
                    `(fetch_single_lineup_for_path) Unable to fetch lineup ${lineupSlug}`,
                    error
                );
            }
        }
    };
};
